var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!isNaN(_vm.item_number))?_c('v-chip',{attrs:{"color":_vm.color}},[_vm._v(" "+_vm._s(_vm.item_number)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }